import React, { Component } from 'react';
import SideHeaderView from './SideHeaderView';
import { url } from '../../../Server/url/GlobalUrl';

class SideHeaderComponent extends Component {

    state = {
        dashboard_left_sidebar: 'aftr-log-lft-sidebar ',
        isToggle:false,
        first_name: '',
        last_name: '',
        wishlist_count:'',
        pending_jobs_count : '',
        accepted_jobs_count : '',
        profile_picture :'',
    }

    componentDidMount() {
        console.log('I am in',localStorage.getItem("token"))
        let data_refresh = {'refresh': localStorage.getItem('refresh')}
      fetch(url + '/api/token/refresh/', {
            method: 'POST',
            headers: {
               'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data_refresh)
        })
            .then((response) => {
             if (response['status'] === 201 || response['status'] === 200) {
                return response.json()
            } else if (response['status'] === 401) {
                this.showCustomModal()
                this.setState({authResponse:'Some Thing went wrong'})
                localStorage.removeItem('refresh')
                localStorage.removeItem('access')
                localStorage.removeItem('is_admin')
            }
            })
            .then((result) => {
                if (result){
                console.log('result.access',result.access)
                localStorage.setItem('token',result.access)
                }
            }
            )
            let authentication = localStorage.getItem("token");   
        fetch((url + "/api/current/?token="+ localStorage.getItem("invalid")), {
                method: 'GET',
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json",
                    'Authorization': 'Bearer ' + authentication,
                    
                },
                })
              .then(res => res.json())
              .then(
                (result) => {
                    if (result.length > 0){
                  console.log('result',result, result[0].first_name)
                  console.log("Profile picture",result[0].profile_picture);
                  this.setState({profile_picture:result[0].profile_picture})
                  this.setState({ first_name: result[0].first_name })
                  this.setState({ last_name: result[0].last_name })
                  console.log('asdasd',this.state.first_name)

              }
//              else{
//                localStorage.removeItem('token');
//              }
                },
                (error) => {
                  console.log('error',error)
                })

              let auth = localStorage.getItem("token");
              fetch(url + "/jobs/dashboard-counts/" ,{
                method:"GET",
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json",
                    'Authorization': 'Bearer ' + auth,

                    
                },
                })
                .then((response) => {
                    if(response['status'] === 201 || response['status'] === 200){
                        return response.json()
                    }
                    else return []
                })
                    .then((data) =>{
                        // this.showCustomModal()
                        // this.setState({authResponse:"Added to the favourites"});
                        console.log("DATA DLSD");
                        this.setState({wishlist_count: data.wishlist_count});
                        this.setState({pending_jobs_count: data.pending_jobs_count});
                        this.setState({accepted_jobs_count: data.accepted_jobs_count});
                        console.log(data)
                      
                    })

                      .catch((err) => {
                       
                        console.log("ERROR",err.body);
            })
         

              
        }

    collaps_sidebar = (event) => {
        const status = !this.state.isToggle;
        this.setState({
            ...this.state,
            dashboard_left_sidebar: 'aftr-log-lft-sidebar collapsed',
            dashboard_left_sidebar: (status) ? 'aftr-log-lft-sidebar collapsed' : "aftr-log-lft-sidebar",
            isToggle:status
        })
    }

    handlelogout = () => {
        console.log('hello all')
        localStorage.removeItem('token')
        localStorage.removeItem('refresh')
        localStorage.removeItem('is_applicant')
        localStorage.removeItem('is_admin')
        localStorage.removeItem('is_candidate')
        localStorage.removeItem('is_pre_screen_applicant')
    }

    render() {
        return <SideHeaderView
            handlelogout = {this.handlelogout}
            last_name = {this.state.last_name}
            first_name = {this.state.first_name}
            profile_picture = {this.state.profile_picture}
            wishlist_count  = {this.state.wishlist_count}
            pending_jobs_count  = {this.state.pending_jobs_count}
            accepted_jobs_count  = {this.state.accepted_jobs_count}
            user_dashboard_left_sidebar={this.state.dashboard_left_sidebar}
            collaps_sidebar={this.collaps_sidebar}
        />
    }
}

export default SideHeaderComponent;